import { PrimarySmallButton } from 'components/ReusableComponents/Button/SmallButtons'
import CopyIcon from 'components/ReusableComponents/Icons/CopyIcon'
import ExclamationIcon from 'components/ReusableComponents/Icons/Exclamation'
import ImageViewerDialog from 'components/ReusableComponents/ImageViewerDialog'
import PdfViewerDialog from 'components/ReusableComponents/PdfViewerDialog'
import TaxInfoDialog from 'components/TaxInfoDialog'
import { userEmailsCanAlwaysRegisterCampaign } from 'constants'
import EditCSMTagsDialog from 'features/EditCSMTagsDialog'
import EditHotelTagsDialog from 'features/EditHotelTagsDialog'
import BillingTaxDetailsDialog from 'features/Hotel/BillingTaxRateDialog'
import ChatbotHelpMessages from 'features/Hotel/ChatbotHelpMessages'
import EditCSMDialog from 'features/Hotel/EditCSMDialog'
import EditStatusDialog from 'features/Hotel/EditStatusDialog'
import FeatureStatuses from 'features/Hotel/FeatureStatuses'
import HostedMessaging from 'features/Hotel/HostedMessaging'
// import AutoReply from 'features/Hotel/HotelCard/AutoReply'
import HotelPreferences from 'features/Hotel/HotelPreferences'
import HotelTags from 'features/Hotel/HotelTags'
import ManagementCompanyChangeDialog, {
  useManagementCompanyChangePermission
} from 'features/Hotel/ManagementCompanyChange'
import PMSSyncStatus from 'features/Hotel/PMSSyncStatus'
import PrepayPreferences from 'features/Hotel/PrepayPreferences'
//import ServiceStartDateDialog from 'features/Hotel/ServiceStartDate'
import SubscriptionBonusDialog from 'features/Hotel/SubscriptionBonusDialog'
import useCopyText from 'hooks/useCopyText'
import { PMSs } from 'main/hotelBrandsAndChains'
import {
  hotelStatuses,
  hotelStatusesCanRegisterCampaign,
  hotelStatusNames
} from 'main/hotelStatuses'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory, useLocation } from 'react-router'
import { useParams } from 'react-router-dom'
import { useToasts } from 'react-toast-notifications'
import ReactTooltip from 'react-tooltip'
import dashboardApi from 'services/api/dashboard'
import hotelApi from 'services/api/hotel'
import internalOnlyApi from 'services/api/internalOnly'
import subsidiariesApi from 'services/api/subsidiaries'
import telcoApi from 'services/api/telcoSetup'
import userApi from 'services/api/user'
import { LandingPageDomainPreference } from 'utils/enums'
import { windowPopup } from 'window-popup'

import {
  selectCurrentHotelId,
  selectIsInternalAdmin,
  selectLoggedinUserEmail
} from '../../accessors/index'
import { getOtherHotelDetails } from '../../actions/hotelDetails'
import AddBlacklistRule, {
  AddMultiBlacklistRule
} from '../../components/ReusableComponents/AddBlacklistRule/index'
import CustomHeader from '../../components/ReusableComponents/HeaderTitles/index'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import MultiPhoneBlacklist from '../../components/ReusableComponents/MultiPhoneBlacklist/index'
import { hotelDetailsBlacklistCategories } from '../../main/blacklistHelpers'
import { getCleanUrl } from '../../utils/common'
import { lowercaseFirstLetter } from '../../utils/helpers'
import Amenities from './Amenities/index'
import BillingDetails from './BillingDetails/index'
import { ReactComponent as BlacklistIcon } from './blacklist.svg'
import BookingEngineBox from './BookingEngine'
import Box from './Box/index'
import Codes from './Codes/index'
import CSMTags from './CSMTags'
import MerchantDocuments from './Documents/MerchantDocuments'
import SubsidiaryDocuments from './Documents/SubsidiaryDocuments'
import EditBillingDetailsDialog from './EditBillingDetailsDialog/index'
import EditPmsEmailsDialog from './EditPmsEmailsDialog/EditPmsEmailsDialog'
import editSettingsStyles from './EditSettingsStyles.module.scss'
import EditSubDomainControlDialog from './EditSubDomainControlDialog/index'
import EditTASettingsDialog from './EditTASettingsDialog/index'
import Exclusions from './Exclusions/index'
import FTPDetailsDialog from './FTPDetails'
import PMSUserCard from './FTPDetails/PMSUserCard'
import { sortSubsidiaryPmsUsersByKind } from './subsidiaryPmsUserKind'
import styles from './Hotel.module.scss'
import Addresses from './HotelCard/Addresses/index'
import HotelCard from './HotelCard/index'
import LastPmsOtp from './LastPmsOtp'
import { ReactComponent as LinkNewTabIcon } from './linkNewTab.svg'
import OnboardingStatuses from './OnboardingStatuses'
import { onboardingStatusTitles } from './OnboardingStatuses/constants'
import { evaluateHotelStatusCheck } from './OnboardingStatuses/evaluateHotelStatusCheck'
import HotelStatusCheckResultDialog from './OnboardingStatuses/HotelStatusCheckResultDialog'
import PhoneNumbers from './PhoneNumbers/index'
import SalesCard from './SalesCard'
import SendACHForm from './SendACHForm'
import Services from './Services/index'

const requestNames = {
  HostMessagingOnHotelsOwnNumber: 'Host messaging on hotel number'
}

export const HotelWrapper = ({ id }) => {
  const { [id]: hotelDetails } = useSelector(s => s.hotelDetails.otherSubsidiaries)
  const loadError = useSelector(
    s => s.hotelDetails.otherSubsidiariesLoadError?.[id]
  )

  const { manageEmails } = useParams()
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getOtherHotelDetails(id))
  }, [dispatch, id])

  if (hotelDetails) {
    return (
      <Hotel
        hotelDetails={hotelDetails}
        getDetails={() => dispatch(getOtherHotelDetails(id))}
        email={manageEmails}
        subsidiaryId={id}
      />
    )
  }

  if (loadError) {
    return (
      <div
        role="alert"
        style={{
          maxWidth: 640,
          margin: '40px auto',
          padding: 20,
          border: '1px solid #f0c5c5',
          background: '#fff5f5',
          borderRadius: 6,
          color: '#7a1f1f'
        }}
      >
        <h2 style={{ margin: 0, marginBottom: 8, fontSize: 18 }}>
          Failed to load hotel details
        </h2>
        <p style={{ margin: 0, marginBottom: 16, fontSize: 14, wordBreak: 'break-word' }}>
          {loadError}
        </p>
        <PrimarySmallButton onClick={() => dispatch(getOtherHotelDetails(id))}>
          Try again
        </PrimarySmallButton>
      </div>
    )
  }

  return <LoadingIndicator />
}

const Hotel = ({ hotelDetails, getDetails, email, subsidiaryId }) => {
  const {
    hotelName,
    primaryWebsiteUrl,
    billingAddress,
    invoiceAddress,
    streetAddress,
    locationExclusions,
    chainExclusions,
    subscriptions,
    trackingInfoUsages,
    deletedExclusion,
    invoiceReconcileInDays,
    invoicePayInDays,
    isAutoPayEnabled,
    billingPaymentAccountDefaultId,
    displayId,
    phoneNumbers,
    telecomProvider,
    pendingRequests,
    isPendingBandwidthPort,
    reviewTripAdvisorMinStars,
    alternateReviewLink,
    billingTaxRate = 0,
    taxId,
    status,
    doingBusinessAsName,
    legalBusinessName,
    supportEmail,
    autoReplySettings,
    usesBonus,
    subscriptionBonus,
    tcrBrandId,
    tcrCampaignId,
    serviceStartDate,
    subsidiaryPmsUsers,
    inviteBackIsDisabled,
    lastStatusChangedBy,
    lastStatusChangedOn,
    lastStatusChangeReason,
    churnedEffectiveDate,
    hostedPhone,
    paymentPeriod,
    achContractSigned,
    customerSuccessManager,
    subsidiaryReferrer,
    subsidiarySalesPerson,
    parentChainCode,
    bookingEngine,
    externalHotelId,
    hasEmailConfig,
    tzTimeZoneName
  } = hotelDetails

  const isLoading = useSelector(s => s.hotelDetails.isLoading)

  const id = useSelector(selectCurrentHotelId)

  const groupName = useSelector(s => s.hotelDetails.groupName)

  const { addToast } = useToasts()

  const isCsmUser = useSelector(s => s.login.isCsmUser)

  const [showBlacklistDialog, setShowBlacklistDialog] = useState(false)
  const [showPhoneBLDialog, setShowPhoneBLDialog] = useState(false)
  const [processing, setProcessing] = useState(false)
  const [blacklistRequestCategory, setBlacklistRequestCategory] = useState('Unknown')
  const [blacklistItemValue, setBlacklistItemValue] = useState('')
  const [multiBlacklistItemValues, setMultiBlacklistItemValues] = useState([])
  const [showMultiBlacklistDialog, setShowMultiBlacklistDialog] = useState(false)
  const [showingEditBillingDetailsDialog, setShowingEditBillingDetailsDialog] = useState()
  const [showingEditTAsettingsDialog, setShowingEditTAsettingsDialog] = useState(false)
  const [showingBillingTaxRateDialog, setShowingBillingTaxRateDialog] = useState(false)
  const [showingTaxDetailsDialog, setShowingTaxDetailsDialog] = useState(false)
  const [showingEditStatusDialog, setShowingEditStatusDialog] = useState(false)
  const [selectedPdf, setSelectedPdf] = useState()
  const [showCustomizeChatBotMessagedDialog, setShowCustomizeChatBotMessagedDialog] =
    useState(false)
  const [showSubscriptionBonusDialog, setShowSubscriptionBonusDialog] = useState(false)
  const [showEditPmsEmailsDialog, setShowEditPmsEmailsDialog] = useState(false)
  const [showPmsUserFTPDialog, setShowPmsUserFTPDialog] = useState(false)
  const [selectedPMSUser, setSelectedPMSUser] = useState()
  const [showHotelTagEditDialog, setShowHotelTagEditDialog] = useState(false)
  const [showCSMTagEditDialog, setShowCSMTagEditDialog] = useState(false)
  const [showEditCSMDialog, setShowEditCSMDialog] = useState(false)
  const [csmNote, setCsmNote] = useState('')

  const [isRegisteringCampaign, setIsRegisteringCampaign] = useState(false)
  const [showManagementCompanyChangeDialog, setShowManagementCompanyChangeDialog] =
    useState(false)
  const [isCheckingHotelStatus, setIsCheckingHotelStatus] = useState(false)
  const [hotelStatusCheckResult, setHotelStatusCheckResult] = useState(null)

  const [showCustomSubDomainControl, setShowCustomSubDomainControl] = useState(false)

  const [isImportingPhoneNumber, setIsImportingPhoneNumber] = useState(false)
  const [isHostingMessagingDialogVisible, setHostingMessagingDialogVisible] = useState()

  const firstRun = useRef(true)

  const pms = useSelector(s => s.hotelDetails.pms)
  const isDisconnected = pms === PMSs.disconnected

  const goodColor = '#32BE39'
  const badColor = '#FF5E5E'

  const copy = useCopyText()

  const history = useHistory()
  const location = useLocation()
  const showProcessingNotification =
    new URLSearchParams(location.search).get('showProcessingNotification') === 'true'

  const cultureCode = useSelector(s => s.hotelDetails.cultureCode)

  const isHotelSetupCompleted = useSelector(s => s.hotelDetails.isPreOnboardingCompleted)
  const [domain, setDomain] = useState()
  const [subdomain, setSubdomain] = useState()
  const [landingPageDomainPreference, setLandingPageDomainPreference] = useState()
  const [defaultChainSubdomain, setDefaultChainSubdomain] = useState()
  const [hotelConfigData, setHotelConfigData] = useState([])
  const [hotelConfigStatus, setHotelConfigStatus] = useState({})

  const getDomainData = () => {
    subsidiariesApi.domain.get().then(res => {
      setDomain(res.domain)
      setSubdomain(res.subdomain)
      setLandingPageDomainPreference(res.landingPageDomainPreferenceText)
      setDefaultChainSubdomain(res.defaultChainSubdomain)
    })
  }

  useEffect(() => {
    getDomainData()
    getHotelConfigStatus()
  }, [])

  // Load CSM note when subsidiaryId is available
  useEffect(() => {
    if (id) {
      // Ensure id is properly formatted as string
      const idStr = String(id).trim().replace(/[{}]/g, '')
      const noteKey = `csm-edit-${idStr}`

      userApi
        .retrieveNote({
          key: noteKey,
          kind: 'csm-assignment',
          subsidiaryId: idStr // Pass explicitly to avoid extraction issues
        })
        .then(response => {
          if (response && response.data) {
            setCsmNote(response.data)
          } else {
            setCsmNote('')
          }
        })
        .catch(err => {
          console.error('Failed to load CSM note:', err)
          console.error('Error details - id:', id, 'formatted:', idStr, 'key:', noteKey)
          setCsmNote('')
        })
    } else {
      console.warn('Hotel component - id is missing or undefined')
    }
  }, [id])

  useEffect(() => {
    if (bookingEngine) {
      getHotelConfigData()
    }
  }, [bookingEngine])

  useEffect(() => {
    if (showProcessingNotification) {
      addToast(
        `Your phone number purchase is being processed. This may take a few minutes.`,
        {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        }
      )
    }
  }, [addToast, showProcessingNotification])

  const displayOnboardingCard = () => {
    if (
      bookingEngine &&
      hotelConfigData &&
      hotelConfigStatus &&
      hotelConfigData.length > 0 &&
      Object.keys(onboardingStatusTitles).some(
        title => title === hotelConfigStatus.currentStage
      )
    ) {
      return true
    }
    return false
  }

  const getHotelConfigData = () => {
    subsidiariesApi
      .hotelConfiguration()
      .then(res => {
        setHotelConfigData(res)
      })
      .catch(() => {
        setHotelConfigData(null)
      })
  }

  const getHotelConfigStatus = () => {
    subsidiariesApi
      .hotelConfigurationStatus()
      .then(res => {
        setHotelConfigStatus(res)
      })
      .catch(() => {
        setHotelConfigStatus(null)
      })
  }

  useEffect(() => {
    if (deletedExclusion && !firstRun.current) {
      addToast(
        `Exclusion with ${
          hotelDetailsBlacklistCategories[lowercaseFirstLetter(deletedExclusion.category)]
        }  ${deletedExclusion.itemValue} deleted successfully!`,
        {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        }
      )
    }
  }, [addToast, deletedExclusion])

  useEffect(() => {
    if (firstRun.current) {
      firstRun.current = false
    }
  })

  useEffect(() => {
    if (email) {
      setShowEditPmsEmailsDialog(true)
    }
  }, [email])

  function blacklistTrackingCode(itemValue) {
    setBlacklistItemValue(itemValue)
    setBlacklistRequestCategory('trackingInfoFull')
    setShowBlacklistDialog(true)
  }

  function multiBlackListTrackingCode(itemValues) {
    setMultiBlacklistItemValues(itemValues)
    setBlacklistRequestCategory('trackingInfoFull')
    setShowMultiBlacklistDialog(true)
  }

  function closeBlacklistDialog() {
    setProcessing(false)
    setShowBlacklistDialog(false)
    setShowMultiBlacklistDialog(false)
    setBlacklistItemValue('')
    setMultiBlacklistItemValues([])
    setBlacklistRequestCategory('Unknown')
  }

  async function handleSubmitBlacklist(model) {
    setProcessing(true)
    await dashboardApi
      .addDirectBlacklist(model)
      .then(() => {
        getDetails()
        addToast(`Exclusion saved successfully!`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while adding exclusion: ${error.message}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        closeBlacklistDialog()
      })
  }

  async function handleSubmitMultiBlacklist(model) {
    setProcessing(true)
    await dashboardApi
      .addDirectBlacklist(multiBlacklistItemValues.map(i => ({ itemValue: i, ...model })))
      .then(() => {
        getDetails()
        addToast(`Exclusion saved successfully!`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while adding exclusion: ${error.message}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        closeBlacklistDialog()
      })
  }

  async function handleMultiPhoneBlacklistSubmit(phones) {
    const model = phones.map(p => ({
      requestCategory: 'InvitedPhoneNumber',
      scope: 'BusinessLocation',
      itemValue: p.replace(/\D/g, '')
    }))
    setShowPhoneBLDialog(false)
    await dashboardApi
      .addDirectBlacklist(model)
      .then(() => {
        getDetails()
        addToast(`Exclusion saved successfully!`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while adding exclusion: ${error.message}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  async function handleUpdateBillingTaxDetails({ billingTaxRate, taxId }) {
    hotelApi
      .updateAsAdmin({ billingTaxRate, taxId }, id)
      .then(() => {
        getDetails()
        addToast(`Updated billingTaxRate`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while updating billing tax rate: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setShowingBillingTaxRateDialog(false)
        getDetails()
      })
  }

  async function handleUpdateTAminRating({
    reviewTripAdvisorMinStars,
    alternateReviewLink
  }) {
    hotelApi
      .updateAsAdmin({ reviewTripAdvisorMinStars, alternateReviewLink }, id)
      .then(() => {
        getDetails()
        getHotelConfigData()
        getHotelConfigStatus()
        addToast(`Updated TripAdvisor min. rating succesfully`, {
          appearance: 'success'
        })
      })
      .catch(error => {
        addToast(`Error while updating hotel: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setShowingEditTAsettingsDialog(false)
      })
  }

  async function updateHotelDetails(data) {
    setProcessing(true)
    hotelApi
      .updateAsAdmin(data, id)
      .then(() => {
        getDetails()
        addToast(`Updated hotel details successfully`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while updating hotel: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setProcessing(false)
        setShowingEditBillingDetailsDialog(false)
      })
  }

  async function updateLoyaltyOutreach(data) {
    setProcessing(true)
    hotelApi
      .updateLoyaltyProgramOutreach(data)
      .then(() => {
        getDetails()
        addToast(`Updated hotel details successfully`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while updating hotel: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setProcessing(false)
      })
  }

  async function handleUpdateCSM(csmUserId) {
    setProcessing(true)
    try {
      // If unassigning (csmUserId is null), we need to remove the role
      if (csmUserId === null) {
        // Find current CSM user to remove their role
        // For now, we'll use updateUserRole with null or handle it differently
        // The backend should handle this, but let's use the updateAsAdmin approach
        await hotelApi.updateAsAdmin({ csmUserId: null }, id)
      } else {
        // Assign new CSM using user role API
        const csmId = parseInt(csmUserId, 10)
        await userApi.updateUserRole({
          dashboardUserId: csmId,
          subsidiaryId: id,
          role: 'Csm'
        })
      }

      getDetails()
      setShowEditCSMDialog(false)
      addToast(`CSM updated successfully`, {
        appearance: 'success',
        autoDismiss: true,
        pauseOnHover: true
      })

      // Reload CSM note
      if (id) {
        const idStr = String(id).trim().replace(/[{}]/g, '')
        const noteKey = `csm-edit-${idStr}`
        userApi
          .retrieveNote({
            key: noteKey,
            kind: 'csm-assignment',
            subsidiaryId: idStr // Pass explicitly to avoid extraction issues
          })
          .then(response => {
            if (response && response.data) {
              setCsmNote(response.data)
            } else {
              setCsmNote('')
            }
          })
          .catch(err => {
            console.error('Failed to reload CSM note:', err)
          })
      }
    } catch (error) {
      addToast(`Error while updating CSM: ${error.toString()}`, {
        appearance: 'error',
        autoDismiss: true
      })
    } finally {
      setProcessing(false)
    }
  }

  async function handleSubDomainChange({
    domain,
    subdomain,
    landingPageDomainPreference
  }) {
    subsidiariesApi.domain
      .update({
        domain,
        subdomain,
        landingPageDomainPreference
      })
      .then(() => {
        getDomainData()
        addToast(`Updated domain succesfully`, {
          appearance: 'success'
        })
        setShowCustomSubDomainControl(false)
      })
      .catch(error => {
        addToast(`Error while updating domain: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
  }

  async function reEnableRegistery({ HostMessagingAuthorizingPartyFullName }) {
    // const activePhoneNumber = phoneNumbers.find(
    //   phoneNumber =>
    //     phoneNumber.status === 'Active' && phoneNumber.capability === 'VoiceAndText'
    // )?.phoneNumber

    // const request = pendingRequests.find(
    //   r => r.requestKind === 'HostMessagingOnHotelsOwnNumber'
    // )

    setProcessing(true)

    // hotelApi
    // .updateAsAdmin({ reservationProxyLine: activePhoneNumber }, id)
    // .then(() =>
    //   hotelApi.updateAsAdmin({
    //     HostMessagingAuthorizingPartyFullName: request.parameters
    //   })
    // )
    internalOnlyApi
      .reEnableHostedMessaging({ HostMessagingAuthorizingPartyFullName })
      .then(() => {
        getDetails()
        getHotelConfigData()
        getHotelConfigStatus()
        addToast(`Updated hotel details successfully`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(`Error while updating hotel: ${error.toString()}`, {
          appearance: 'error',
          autoDismiss: true
        })
      })
      .finally(() => {
        setProcessing(false)
      })
  }

  async function registerCampaign() {
    setIsRegisteringCampaign(true)
    hotelApi
      .registerCampaign()
      .then(() => {
        getDetails()
        setIsRegisteringCampaign(false)
      })
      .catch(error => {
        if (error.message.includes('ReservationHotLine is required')) {
          addToast(`Reservation hotline is required`, {
            appearance: 'warning',
            autoDismiss: true
          })
        } else {
          addToast(`${error.message.toString()}`, {
            appearance: 'error',
            autoDismiss: true
          })
        }
        setIsRegisteringCampaign(false)
      })
  }

  async function providerImport() {
    setIsImportingPhoneNumber(true)
    telcoApi
      .campaignImportPhoneNumber({ subsidiaryId: id })
      .then(res => {
        addToast(`${res}`, {
          appearance: 'success',
          autoDismiss: true,
          pauseOnHover: true
        })
      })
      .catch(error => {
        addToast(
          `Error while import button: ${error.toString().replace('Error: Error:', '')}`,
          {
            appearance: 'error',
            autoDismiss: true
          }
        )
        setIsImportingPhoneNumber(false)
      })
    setIsImportingPhoneNumber(false)
  }

  async function handleUpdateCSM(selectedCsmId) {
    setProcessing(true)
    try {
      // Get current CSM user ID by matching name
      const csmUsers = await userApi.getCustomerSuccessManagers()
      const currentCsm = csmUsers.find(csm => csm.fullName === customerSuccessManager)

      // If unassigning
      if (!selectedCsmId && currentCsm) {
        await userApi.deleteUserRole({
          dashboardUserId: currentCsm.id,
          subsidiaryId: id
        })
      }
      // If assigning new CSM
      else if (selectedCsmId) {
        // Delete old CSM role if exists
        if (currentCsm) {
          await userApi.deleteUserRole({
            dashboardUserId: currentCsm.id,
            subsidiaryId: id
          })
        }
        // Add new CSM role
        await userApi.updateUserRole({
          dashboardUserId: selectedCsmId,
          subsidiaryId: id,
          role: 'Csm'
        })
      }

      getDetails() // Refresh hotel details
      addToast('CSM updated successfully', {
        appearance: 'success',
        autoDismiss: true,
        pauseOnHover: true
      })
      setShowEditCSMDialog(false)
    } catch (error) {
      addToast(`Error while updating CSM: ${error.toString()}`, {
        appearance: 'error',
        autoDismiss: true
      })
    } finally {
      setProcessing(false)
    }
  }

  const sortedServices = hotelDetails.subsidiaryServices
    ? hotelDetails.subsidiaryServices.reduce((prev, curr) => {
        let copy = { ...prev }

        if (copy[curr.kind]) {
          copy[curr.kind].push(curr)
        } else {
          copy[curr.kind] = [curr]
        }

        return copy
      }, {})
    : {}

  const isInternalAdmin = useSelector(selectIsInternalAdmin)
  const canCheckHotelStatus = isInternalAdmin || isCsmUser

  const handleCheckHotelStatus = async () => {
    if (isCheckingHotelStatus) {
      return
    }

    setIsCheckingHotelStatus(true)

    try {
      const [configuration] = (await subsidiariesApi.hotelConfiguration()) || []
      const { isCompleted, pendingSteps } = evaluateHotelStatusCheck(configuration)

      getDetails()
      getHotelConfigData()
      getHotelConfigStatus()

      setHotelStatusCheckResult({
        isCompleted,
        pendingSteps,
        statusName: isCompleted
          ? hotelStatusNames[hotelStatuses.BasicAccount]
          : hotelStatusNames[status] || status
      })
    } catch (error) {
      addToast(`Error while checking hotel status: ${error.toString()}`, {
        appearance: 'error',
        autoDismiss: true
      })
    } finally {
      setIsCheckingHotelStatus(false)
    }
  }

  const userEmail = useSelector(selectLoggedinUserEmail)

  const canUserAlwaysRegisterCampaign =
    userEmailsCanAlwaysRegisterCampaign.includes(userEmail)

  const { canChangeManagementCompany } = useManagementCompanyChangePermission()

  const hasActiveEmailSubscription = subscriptions?.some(
    s => s.plan === 'Email' && s.isActive
  )

  const showEmailConfigWarning = hasActiveEmailSubscription && !hasEmailConfig

  const [showRegisterCampaignButton, setShowRegisterCampaignButton] = useState(false)

  return (
    <div className={styles.container}>
      <CustomHeader width={1000} isFixed={true}>
        <div className={styles.header}>
          <h1 className={styles.headerTitle}>
            {hotelName}{' '}
            {isInternalAdmin && (
              <>
                <span className={styles.displayId}>#{displayId}</span>
              </>
            )}
          </h1>
          <p className={styles.headerDesc}>
            <a href={primaryWebsiteUrl} target="_blank" rel="noopener noreferrer">
              {getCleanUrl(primaryWebsiteUrl)} <LinkNewTabIcon />
            </a>
          </p>
        </div>
      </CustomHeader>
      <ReactTooltip />
      {showEmailConfigWarning && (
        <div className={styles.emailConfigWarning}>
          <ExclamationIcon />
          <div>
            <strong>Email configuration missing</strong>
            <p>
              This hotel has an active Email subscription but email sending is not
              configured. Please set up the email configuration to enable email campaigns.
            </p>
          </div>
        </div>
      )}
      {isLoading || processing ? (
        <LoadingIndicator />
      ) : (
        <>
          <HotelCard {...hotelDetails} groupName={groupName} />
          <div className={styles.cols}>
            <div className={styles.main}>
              <>
                {showBlacklistDialog && (
                  <AddBlacklistRule
                    handleConfirm={handleSubmitBlacklist}
                    handleClose={closeBlacklistDialog}
                    itemValue={blacklistItemValue}
                    isIndependent={parentChainCode === 'independent'}
                  />
                )}
                {showMultiBlacklistDialog && (
                  <AddMultiBlacklistRule
                    handleConfirm={handleSubmitMultiBlacklist}
                    handleClose={closeBlacklistDialog}
                    itemValues={multiBlacklistItemValues}
                    requestCategory={blacklistRequestCategory}
                  />
                )}
                {showPhoneBLDialog && (
                  <MultiPhoneBlacklist
                    handleCancel={() => setShowPhoneBLDialog(false)}
                    handleConfirm={handleMultiPhoneBlacklistSubmit}
                  />
                )}
                {showingEditBillingDetailsDialog && (
                  <EditBillingDetailsDialog
                    invoiceReconcileInDays={invoiceReconcileInDays}
                    invoicePayInDays={invoicePayInDays}
                    isAutoPayEnabled={isAutoPayEnabled}
                    handleConfirm={updateHotelDetails}
                    handleClose={() => setShowingEditBillingDetailsDialog(false)}
                    paymentPeriod={paymentPeriod}
                  />
                )}
                {showingEditTAsettingsDialog && (
                  <EditTASettingsDialog
                    subsidiaryId={id}
                    handleClose={() => setShowingEditTAsettingsDialog(false)}
                    reviewTripAdvisorMinStars={reviewTripAdvisorMinStars}
                    alternateReviewLink={alternateReviewLink}
                    handleConfirm={handleUpdateTAminRating}
                  />
                )}
                {showCustomSubDomainControl && (
                  <EditSubDomainControlDialog
                    handleClose={() => setShowCustomSubDomainControl(false)}
                    domain={domain}
                    subdomain={subdomain}
                    landingPageDomainPreference={landingPageDomainPreference}
                    defaultChainSubdomain={defaultChainSubdomain}
                    handleConfirm={handleSubDomainChange}
                  />
                )}
                {showingBillingTaxRateDialog && (
                  <BillingTaxDetailsDialog
                    handleClose={() => setShowingBillingTaxRateDialog(false)}
                    billingTaxRate={billingTaxRate}
                    handleConfirm={handleUpdateBillingTaxDetails}
                  />
                )}
                {showingTaxDetailsDialog && (
                  <TaxInfoDialog
                    onClose={() => setShowingTaxDetailsDialog(false)}
                    closeButtonText="Close"
                    defaultDoingBusinessAsName={doingBusinessAsName}
                    defaultSupportEmail={supportEmail}
                    defaultLegalBusinessName={legalBusinessName}
                    defaultTaxId={taxId}
                  />
                )}
                {showingEditStatusDialog && (
                  <EditStatusDialog
                    status={status}
                    tzTimeZoneName={tzTimeZoneName}
                    churnedEffectiveDate={churnedEffectiveDate}
                    onClose={() => setShowingEditStatusDialog(false)}
                    onSave={() => {
                      getDetails()
                      setShowingEditStatusDialog(false)
                    }}
                  />
                )}
                {showManagementCompanyChangeDialog && (
                  <ManagementCompanyChangeDialog
                    displayId={displayId}
                    merchantId={hotelDetails.merchantId}
                    hotelName={hotelName}
                    onClose={() => setShowManagementCompanyChangeDialog(false)}
                    onSuccess={() => {
                      getDetails()
                    }}
                  />
                )}
                {showCustomizeChatBotMessagedDialog && (
                  <ChatbotHelpMessages
                    onClose={() => setShowCustomizeChatBotMessagedDialog(false)}
                  />
                )}
                {showEditPmsEmailsDialog && (
                  <EditPmsEmailsDialog
                    onClose={() => setShowEditPmsEmailsDialog(false)}
                    subsidiaryPmsUsers={subsidiaryPmsUsers}
                    email={email}
                  />
                )}
                {showPmsUserFTPDialog && selectedPMSUser && (
                  <FTPDetailsDialog
                    onClose={() => setShowPmsUserFTPDialog(false)}
                    username={selectedPMSUser.ftpUserName}
                    password={selectedPMSUser.ftpPassword}
                  />
                )}
                {selectedPdf && selectedPdf?.contentType.includes('image') && (
                  <ImageViewerDialog
                    mediaUrl={selectedPdf.path}
                    onClose={() => setSelectedPdf(null)}
                  />
                )}
                {selectedPdf && selectedPdf?.contentType === 'application/pdf' && (
                  <PdfViewerDialog
                    pdfUrl={selectedPdf.path}
                    downloadUrl={selectedPdf.downloadablePath}
                    onClose={() => setSelectedPdf(null)}
                    title={selectedPdf.name}
                  />
                )}
                <div className={styles.doubleRow}>
                  {isInternalAdmin && (
                    <Box title={hotelStatusNames[status] || 'Unknown'}>
                      <div className={editSettingsStyles.container}>
                        {lastStatusChangedOn && (
                          <div style={{ fontSize: 14, color: '#9d8e8e', marginTop: 8 }}>
                            set by {lastStatusChangedBy} on{' '}
                            {moment(lastStatusChangedOn).format('MMM DD, YYYY')}
                          </div>
                        )}
                        {lastStatusChangeReason && (
                          <div style={{ fontSize: 14, color: '#9d8e8e', marginTop: 8 }}>
                            {lastStatusChangeReason}
                          </div>
                        )}
                        {churnedEffectiveDate && status !== 'Churned' && (
                          <div style={{ fontSize: 14, color: '#9d8e8e', marginTop: 8 }}>
                            Churned Date: {moment(churnedEffectiveDate).format('MMM DD, YYYY')}
                          </div>
                        )}
                        <button
                          className={editSettingsStyles.editButton}
                          onClick={() => setShowingEditStatusDialog(true)}
                        >
                          Edit
                        </button>
                      </div>
                    </Box>
                  )}
                  <Box
                    cornerButtonText="Edit"
                    hasCornerButton
                    title={'Tags'}
                    onClickCornerButton={() => setShowHotelTagEditDialog(true)}
                  >
                    {!showHotelTagEditDialog && <HotelTags />}
                  </Box>
                  {showHotelTagEditDialog && (
                    <EditHotelTagsDialog
                      onClose={() => setShowHotelTagEditDialog(false)}
                    />
                  )}
                </div>
                {showSubscriptionBonusDialog && (
                  <SubscriptionBonusDialog
                    onClose={() => setShowSubscriptionBonusDialog(false)}
                    usesBonus={usesBonus}
                    subscriptionBonus={subscriptionBonus}
                    onSave={({ usesBonus, subscriptionBonus }) => {
                      updateHotelDetails({ usesBonus, subscriptionBonus })
                      setShowSubscriptionBonusDialog(false)
                    }}
                  />
                )}
                {isInternalAdmin && (
                  <div className={isCsmUser ? styles.doubleRow : null}>
                    {pendingRequests &&
                      pendingRequests.filter(
                        r => r.requestKind !== 'HostMessagingOnHotelsOwnNumber'
                      ).length > 0 && (
                        <Box title="Requests history">
                          {pendingRequests
                            .filter(
                              r => r.requestKind !== 'HostMessagingOnHotelsOwnNumber'
                            )
                            .filter(r => r.requestKind !== 'PmsPasswordChange')
                            .filter(r => r.requestKind !== 'TelecomChangeProvider')
                            .map(r => (
                              <div key={r.requestKind} className={styles.request}>
                                <span className={styles.requestName}>
                                  {requestNames[r.requestKind] || r.requestKind}
                                </span>
                                <span className={styles.requestParam}>
                                  Parameters: {r.parameters}
                                </span>
                              </div>
                            ))}
                        </Box>
                      )}

                    {isCsmUser && (
                      <Box
                        cornerButtonText="Edit"
                        hasCornerButton
                        title={'CSM Tags'}
                        onClickCornerButton={() => setShowCSMTagEditDialog(true)}
                      >
                        {!showCSMTagEditDialog && <CSMTags />}
                      </Box>
                    )}
                    {showCSMTagEditDialog && (
                      <EditCSMTagsDialog onClose={() => setShowCSMTagEditDialog(false)} />
                    )}
                  </div>
                )}
                {showEditCSMDialog && (
                  <EditCSMDialog
                    currentCsmName={customerSuccessManager}
                    subsidiaryId={id}
                    onClose={() => setShowEditCSMDialog(false)}
                    onConfirm={handleUpdateCSM}
                  />
                )}
                <Addresses
                  billingAddress={billingAddress}
                  invoiceAddress={invoiceAddress}
                />
                <div className={styles.doubleRow}>
                  <FeatureStatuses
                    phoneNumbers={phoneNumbers}
                    status={status}
                    tcrBrandId={tcrBrandId}
                    tcrCampaignId={tcrCampaignId}
                    inviteBackIsDisabled={inviteBackIsDisabled}
                    reservationHotLine={hotelDetails.reservationHotLine}
                    serviceStartDate={serviceStartDate}
                    onlySendsOTAMessages={hotelDetails.isJustAutomatedOtaCampaigns}
                    reviewTripAdvisorPage={hotelDetails.reviewTripAdvisorPage}
                    subscriptions={subscriptions}
                    isChatBotEnabled={hotelDetails.isChatBotEnabled}
                    isUsingDefaultOpera={pms === PMSs.operadefault}
                    enrichedGuestPercentage={hotelDetails.enrichedGuestPercentage}
                    areMarketingCampaignsEnabled={
                      hotelDetails.areMarketingCampaignsEnabled
                    }
                    areOTAMarketingCampaignsEnabled={
                      hotelDetails.areOTAMarketingCampaignsEnabled
                    }
                    areReviewCampaignsEnabled={hotelDetails.areReviewCampaignsEnabled}
                    OTArateCodesCount={hotelDetails.OTArateCodesCount}
                    isPmsSyncing={hotelDetails.isPmsSyncing}
                    hasChatbotResponses={hotelDetails.hasChatbotResponses}
                  />
                  <div>
                    <Box title="Legal">
                      <div className={editSettingsStyles.container}>
                        <button
                          className={editSettingsStyles.editButton}
                          onClick={() => setShowingTaxDetailsDialog(true)}
                        >
                          Edit
                        </button>
                        <div className={styles.boxRowHolder}>
                          <p
                            className={styles.boxLabel}
                            style={{ marginBottom: 2, marginTop: 5 }}
                          >
                            Name (as on tax return)
                          </p>
                          <p className={styles.boxRowPrimary}>
                            {legalBusinessName || 'Missing'}
                          </p>
                        </div>
                        <div className={styles.boxRowHolder}>
                          <p className={styles.boxLabel} style={{ marginBottom: 2 }}>
                            Doing business as
                          </p>
                          <p className={styles.boxRowPrimary}>
                            {doingBusinessAsName || 'Missing'}
                          </p>
                        </div>
                        <div className={styles.boxRowHolder}>
                          <p className={styles.boxLabel} style={{ marginBottom: 2 }}>
                            Support email
                          </p>
                          <p className={styles.boxRowPrimary}>
                            {supportEmail || 'Missing'}
                          </p>
                        </div>
                        <div className={styles.boxRowHolder}>
                          <p className={styles.boxLabel} style={{ marginBottom: 2 }}>
                            {cultureCode === 'en-CA' ? 'Corporation number' : 'EIN'}
                          </p>
                          <p className={styles.boxRowPrimary}>{taxId || 'Missing'}</p>
                        </div>
                        <div style={{ display: 'flex', marginTop: 15 }}>
                          <div
                            className={styles.boxRowHolder}
                            style={{ marginRight: 30 }}
                          >
                            <p className={styles.boxLabel} style={{ marginBottom: 2 }}>
                              TCR Brand Id
                            </p>
                            <p className={styles.boxRowPrimary}>
                              {tcrBrandId || 'Missing'}{' '}
                              {tcrBrandId && (
                                <button onClick={() => copy(tcrBrandId)}>
                                  <CopyIcon width={14} />
                                </button>
                              )}
                            </p>
                          </div>
                          <p />
                          <div className={styles.boxRowHolder}>
                            <p className={styles.boxLabel} style={{ marginBottom: 2 }}>
                              TCR Campaign Id
                            </p>
                            <p
                              className={styles.boxRowPrimary}
                              onDoubleClick={() => setShowRegisterCampaignButton(true)}
                            >
                              {tcrCampaignId || 'Missing'}{' '}
                              {tcrCampaignId && (
                                <button onClick={() => copy(tcrCampaignId)}>
                                  <CopyIcon width={14} />
                                </button>
                              )}
                            </p>
                          </div>
                        </div>
                        {isInternalAdmin &&
                          (hotelStatusesCanRegisterCampaign.includes(status) ||
                            canUserAlwaysRegisterCampaign ||
                            showRegisterCampaignButton) && (
                            <>
                              <PrimarySmallButton
                                style={{ width: '100%', marginTop: 15 }}
                                onClick={registerCampaign}
                                disabled={
                                  isRegisteringCampaign ||
                                  !(
                                    doingBusinessAsName &&
                                    legalBusinessName &&
                                    supportEmail &&
                                    taxId &&
                                    streetAddress
                                  )
                                }
                              >
                                {isRegisteringCampaign
                                  ? 'Registering...'
                                  : 'Register campaign'}
                              </PrimarySmallButton>
                              {!streetAddress && (
                                <p className={styles.infoText}>
                                  <ExclamationIcon />
                                  Missing street in address
                                </p>
                              )}
                              {legalBusinessName &&
                                status === 'PendingCampaignBrandRegistration' && (
                                  <div className={styles.legalLookUpButtons}>
                                    <button
                                      onClick={() =>
                                        windowPopup(
                                          1000,
                                          800,
                                          `https://opencorporates.com/companies?q=${doingBusinessAsName}`
                                        )
                                      }
                                    >
                                      Look up on opencorporates.com <LinkNewTabIcon />
                                    </button>
                                    <button
                                      onClick={() =>
                                        windowPopup(
                                          1000,
                                          800,
                                          `https://www.dnb.com/site-search-results.html#AllSearch=${doingBusinessAsName}`
                                        )
                                      }
                                    >
                                      Look up on dun&amp;bradstreet <LinkNewTabIcon />
                                    </button>
                                  </div>
                                )}
                            </>
                          )}
                        {isInternalAdmin &&
                          status === hotelStatuses.PendingCampaignProviderImport &&
                          phoneNumbers.length > 0 && (
                            <PrimarySmallButton
                              style={{ width: '100%', marginTop: 15 }}
                              onClick={providerImport}
                              disabled={isImportingPhoneNumber}
                            >
                              {isImportingPhoneNumber
                                ? 'Processing...'
                                : 'Associate phone number with campaign'}
                            </PrimarySmallButton>
                          )}
                      </div>
                      <a
                        href={`https://csp.campaignregistry.com/events?ascendingOrder=false&campaignUid=${tcrCampaignId}&sortField=createDate`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ marginTop: 10, display: 'block' }}
                      >
                        Show details on Campaign Registry
                      </a>
                    </Box>
                    <PMSSyncStatus />
                  </div>
                </div>
                <div
                  className={hotelDetails.merchantId !== -100 ? styles.doubleRow : null}
                >
                  {hotelDetails.merchantId !== -100 && (
                    <MerchantDocuments
                      merchantId={hotelDetails.merchantId}
                      onClick={setSelectedPdf}
                    />
                  )}
                  <SubsidiaryDocuments onClick={setSelectedPdf} />
                </div>
                {isInternalAdmin && <Amenities data={sortedServices} />}
                {isInternalAdmin && (
                  <div className={styles.doubleRow}>
                    <Codes
                      handleBlacklist={blacklistTrackingCode}
                      handleMultiBlacklist={multiBlackListTrackingCode}
                      title="Tracking info"
                      data={trackingInfoUsages}
                    />
                    {/* <AutoReply autoReplySettings={autoReplySettings} /> */}
                  </div>
                )}
                <Exclusions
                  title="Property exclusions"
                  data={locationExclusions}
                  handleReload={getDetails}
                />
                {parentChainCode !== 'independent' && (
                  <Exclusions title="Chain exclusions" data={chainExclusions} />
                )}

                <div className={styles.controls}>
                  {isInternalAdmin && (
                    <button
                      className={styles.control}
                      onClick={() => setShowBlacklistDialog(true)}
                    >
                      <BlacklistIcon />
                      Add exclusions
                    </button>
                  )}
                  {canChangeManagementCompany && (
                    <button
                      className={styles.control}
                      onClick={() => setShowManagementCompanyChangeDialog(true)}
                    >
                      Management Company Change
                    </button>
                  )}
                </div>
              </>
            </div>
            <div className={styles.sidebar}>
              <SalesCard
                customerSuccessManager={customerSuccessManager}
                salesPerson={
                  subsidiarySalesPerson &&
                  `${subsidiarySalesPerson.firstName} ${subsidiarySalesPerson.lastName}`
                }
                referrer={subsidiaryReferrer && subsidiaryReferrer.name}
                csmNote={csmNote}
                onEditClick={isInternalAdmin ? () => setShowEditCSMDialog(true) : null}
              />
              {serviceStartDate && (
                <Box
                  title={
                    <>
                      {moment().isAfter(serviceStartDate) && !isHotelSetupCompleted && (
                        <span className={styles.redError}>Service didn't start on</span>
                      )}
                      {moment().isAfter(serviceStartDate) && isHotelSetupCompleted && (
                        <>Service started on</>
                      )}
                      {moment().isBefore(serviceStartDate) && <>Service will start on</>}
                    </>
                  }
                  hasCornerButton={false}
                >
                  <p>{moment(serviceStartDate).format('MMM DD, YYYY, hh:mm A')}</p>
                </Box>
              )}
              {displayOnboardingCard() && (
                <OnboardingStatuses
                  setShowingTaxDetailsDialog={setShowingTaxDetailsDialog}
                  setHostingMessagingDialogVisible={setHostingMessagingDialogVisible}
                  setShowingEditTAsettingsDialog={setShowingEditTAsettingsDialog}
                  hotelConfigData={hotelConfigData[0]}
                  hotelConfigStatus={hotelConfigStatus}
                  hasHostedMessagesSet={hostedPhone.fullName}
                  {...hotelDetails}
                  canCheckHotelStatus={canCheckHotelStatus}
                  isCheckingHotelStatus={isCheckingHotelStatus}
                  onCheckHotelStatus={handleCheckHotelStatus}
                />
              )}
              <Box
                title="Hotel Emails"
                hasCornerButton
                cornerButtonText="Edit"
                onClickCornerButton={() => setShowEditPmsEmailsDialog(true)}
              >
                <div className={styles.boxRowHolder}>
                  {sortSubsidiaryPmsUsersByKind(subsidiaryPmsUsers).map(user => (
                    <PMSUserCard
                      key={user.id}
                      user={user}
                      setSelectedPMSUser={setSelectedPMSUser}
                      setShowPmsUserFTPDialog={setShowPmsUserFTPDialog}
                    />
                  ))}
                </div>
              </Box>
              <LastPmsOtp isCsmUser={isCsmUser} isInternalAdmin={isInternalAdmin} />
              <BookingEngineBox
                bookingEngine={bookingEngine}
                id={id}
                lastAutomatedInfoSyncOn={hotelDetails.lastAutomatedInfoSyncOn}
                subsidiaryId={id}
                externalHotelId={externalHotelId}
              />
              {paymentPeriod === 'PostPay' && (
                <Services
                  status={status}
                  subscriptions={subscriptions}
                  billingTaxRate={billingTaxRate}
                  onSave={updateHotelDetails}
                />
              )}
              {paymentPeriod !== 'PostPay' && (
                <PrepayPreferences
                  paymentPeriod={paymentPeriod}
                  subscriptions={subscriptions}
                  isInternalAdmin={isInternalAdmin}
                  hotelDetails={hotelDetails}
                  subsidiaryId={subsidiaryId}
                />
              )}
              {isInternalAdmin && (
                <BillingDetails
                  invoiceReconcileInDays={invoiceReconcileInDays}
                  invoicePayInDays={invoicePayInDays}
                  isAutoPayEnabled={isAutoPayEnabled}
                  billingPaymentAccountDefaultId={billingPaymentAccountDefaultId}
                  handleOpenEditDialog={() => setShowingEditBillingDetailsDialog(true)}
                />
              )}
              {isInternalAdmin && (
                <>
                  <HotelPreferences
                    updateHotelDetails={updateHotelDetails}
                    updateLoyaltyOutreach={updateLoyaltyOutreach}
                    hotelDetails={hotelDetails}
                  />
                  {isDisconnected && (
                    <Box
                      title="Subscription bonus"
                      hasCornerButton
                      onClickCornerButton={() => setShowSubscriptionBonusDialog(true)}
                    >
                      <div className={editSettingsStyles.text}>
                        Subscripton bonus
                        <span
                          className={editSettingsStyles.value}
                          style={{ color: usesBonus ? goodColor : badColor }}
                        >
                          {usesBonus ? 'Enabled' : 'Disabled'}
                        </span>
                      </div>
                      {usesBonus && (
                        <div className={editSettingsStyles.text}>{subscriptionBonus}</div>
                      )}
                    </Box>
                  )}
                  <Box
                    title="Chatbot help messages"
                    hasCornerButton
                    onClickCornerButton={() =>
                      setShowCustomizeChatBotMessagedDialog(true)
                    }
                  />
                  <Box
                    title="Rate codes"
                    hasCornerButton
                    onClickCornerButton={() => history.push(`/rate-codes`)}
                  />
                  <PhoneNumbers
                    numbers={phoneNumbers}
                    telecomProvider={telecomProvider}
                    isPendingBandwidthPort={isPendingBandwidthPort}
                    handleReload={getDetails}
                  />
                </>
              )}
              <div className={editSettingsStyles.wrapper}>
                <Box title="Review settings">
                  <div className={editSettingsStyles.container}>
                    <button
                      className={editSettingsStyles.editButton}
                      onClick={() => setShowingEditTAsettingsDialog(true)}
                    >
                      Edit
                    </button>
                    <div className={editSettingsStyles.text}>
                      Min. rating for ext review:{' '}
                      <span className={editSettingsStyles.value}>
                        {reviewTripAdvisorMinStars >= 10 ? (
                          'Disabled'
                        ) : (
                          <>
                            {reviewTripAdvisorMinStars}{' '}
                            <span className={editSettingsStyles.star}>★</span>
                          </>
                        )}
                      </span>
                    </div>
                  </div>
                </Box>
              </div>
              <div>
                <Box title="Guest landing page URL">
                  <div className={styles.subDomainControl}>
                    <button
                      className={editSettingsStyles.editButton}
                      onClick={() => setShowCustomSubDomainControl(true)}
                    >
                      Edit
                    </button>
                    <div className={styles.domainName}>
                      {landingPageDomainPreference ===
                      LandingPageDomainPreference.Default ? (
                        <span>
                          {defaultChainSubdomain}.{domain}
                        </span>
                      ) : (
                        <span>
                          {subdomain}.{domain}
                        </span>
                      )}
                    </div>
                    <div className={styles.domainDescription}>
                      {landingPageDomainPreference ===
                        LandingPageDomainPreference.Default && 'Default domain'}
                      {landingPageDomainPreference ===
                        LandingPageDomainPreference.Subdomain && 'Custom subdomain'}
                      {landingPageDomainPreference ===
                        LandingPageDomainPreference.Domain && 'Custom domain'}
                    </div>
                  </div>
                </Box>
              </div>
              {isInternalAdmin && (
                <div className={editSettingsStyles.wrapper}>
                  <Box title="Billing tax Details">
                    <div className={editSettingsStyles.container}>
                      <button
                        className={editSettingsStyles.editButton}
                        onClick={() => setShowingBillingTaxRateDialog(true)}
                      >
                        Edit
                      </button>
                      <div className={editSettingsStyles.text}>
                        Billing rax rate
                        <span className={editSettingsStyles.value}>{billingTaxRate}</span>
                      </div>
                    </div>
                  </Box>
                </div>
              )}
              {isInternalAdmin && (
                <HostedMessaging
                  reservationHotLine={hotelDetails.reservationHotLine}
                  reservationProxyLine={hotelDetails.reservationProxyLine}
                  fullName={hostedPhone.fullName}
                  status={hostedPhone.status}
                  reEnableRegistery={reEnableRegistery}
                  setDialogVisible={setHostingMessagingDialogVisible}
                  isDialogVisible={isHostingMessagingDialogVisible}
                  phoneNumbers={phoneNumbers}
                />
              )}
              <SendACHForm achContractSigned={achContractSigned} />
            </div>
          </div>
        </>
      )}
      {hotelStatusCheckResult && (
        <HotelStatusCheckResultDialog
          isCompleted={hotelStatusCheckResult.isCompleted}
          pendingSteps={hotelStatusCheckResult.pendingSteps}
          statusName={hotelStatusCheckResult.statusName}
          onClose={() => setHotelStatusCheckResult(null)}
        />
      )}
      {showEditCSMDialog && (
        <EditCSMDialog
          currentCsmName={customerSuccessManager}
          subsidiaryId={id}
          onClose={() => setShowEditCSMDialog(false)}
          onConfirm={handleUpdateCSM}
        />
      )}
    </div>
  )
}
